import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import { propTypes } from 'formsy-react';
import withFormsyValidations from '../withFormsyValidations';

class GLNInput extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      setValue: PropTypes.func.isRequired,
      required: PropTypes.bool,
      disabled: PropTypes.bool,
      onChange: PropTypes.func.isRequired,
      ...propTypes,
    };
  }

  static get defaultProps() {
    return {
      required: false,
      disabled: false,
      className: '',
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { name, setValue, onChange } = this.props;
    const { value } = event.currentTarget;
    setValue(value, false); // this is the performance thief
    onChange(name, value);
  }

  render() {
    // Dont remove onChange from below.
    const {
      value,
      name,
      id,
      className,
      errorMessage,
      isValid,
      required,
      disabled,
    } = this.props;

    return (
      <div>
        <Input
          invalid={!isValid}
          type="string"
          id={id}
          className={className}
          required={required}
          disabled={disabled}
          value={value}
          name={name}
          onChange={this.changeValue}
        />
        <span>{errorMessage}</span>
      </div>
    );
  }
}

export default withFormsyValidations(GLNInput, () => ({
  GLN(values, value) {
    if (!value) return true;

    // for some reason coops gln numbers are not verifying using the check digits
    return value.length === 13; // && verifyCheckDidigt(value);
  },
}));
